import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionHelper } from '../../../helpers/permission.helper';

@Component({
  standalone: false,
  selector: 'app-deadline-details-modal',
  templateUrl: './deadline-details-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class DeadlineDetailsModalComponent {
  @Input() orderDay: any;

  @Output() readonly responseChanged = new EventEmitter();

  constructor(public permissionHelper: PermissionHelper) {}

  emitFalse(): void {
    this.responseChanged.emit(false);
  }
}
